"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSidebarProps = void 0;
var useTopItems_1 = require("./useTopItems");
var useBottomItems_1 = require("./useBottomItems");
var useUserData_1 = require("./useUserData");
var useSidebarProps = function (props) {
    var topItems = (0, useTopItems_1.useTopItems)(props);
    var bottomItems = (0, useBottomItems_1.useBottomItems)();
    var userData = (0, useUserData_1.useUserData)(props);
    return {
        topItems: topItems,
        bottomItems: bottomItems,
        userData: userData,
    };
};
exports.useSidebarProps = useSidebarProps;
